class t extends window.HTMLElement {
  constructor() {
    ;(super(),
      (this.button = this.querySelector(':scope > button')),
      (this.video = this.querySelector(':scope > video')),
      this.button &&
        this.video &&
        (this.button.addEventListener('click', this.onButtonClick.bind(this)),
        this.video.addEventListener('click', this.onVideoClick.bind(this)),
        this.video.addEventListener('play', this.onVideoPlay.bind(this)),
        this.video.addEventListener('pause', this.onVideoPause.bind(this)),
        this.video.addEventListener('ended', this.onVideoPause.bind(this))))
  }
  onButtonClick(e) {
    ;(e.preventDefault(),
      this.video.paused ? this.video.play() : this.video.pause())
  }
  onVideoClick(e) {
    ;(e.preventDefault(), this.video.paused || this.video.pause())
  }
  onVideoPlay() {
    ;(this.classList.add('is-playing'),
      this.button.setAttribute('aria-pressed', 'true'))
    const e = this.button.querySelector('.sr-only')
    e && (e.textContent = 'Pause video')
  }
  onVideoPause() {
    ;(this.classList.remove('is-playing'),
      this.button.setAttribute('aria-pressed', 'false'))
    const e = this.button.querySelector('.sr-only')
    e && (e.textContent = 'Play video')
  }
  disconnectedCallback() {
    ;(this.classList.remove('is-playing'),
      this.button &&
        this.button.removeEventListener('click', this.onButtonClick),
      this.video &&
        (this.video.removeEventListener('click', this.onVideoClick),
        this.video.removeEventListener('play', this.onVideoPlay),
        this.video.removeEventListener('pause', this.onVideoPause),
        this.video.removeEventListener('ended', this.onVideoPause)))
  }
}
window.customElements.define('video-player', t)
